module.exports = __webpack_public_path__ + "static/media/home_composition_graph.8147c000.gif";